import { ChangeEvent } from "react"

export default function TextInput({
    label,
    id,
    value,
    handleChange,
    required,
    showInvalid,
    type,
}: {
    label: string,
    id: string,
    value?: string,
    handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void,
    required: boolean,
    showInvalid: boolean,
    type?: string,
}) {
    
    return (
        <div className="flex flex-col justify-start items-start gap-1">
            <label className={`text-[12px] text-secondary ${required ? "required" : ""}`}>{label}</label>
            <input
                onChange={handleChange}
                required={required}
                id={id}
                name={id}
                value={value}
                type={type}
                className={`${showInvalid ? "invalid:border-pink-500 invalid:text-pink-600" : ""} w-full border border-outline bg-dark text-white rounded-lg px-4 py-3 text-[14px]`}
            />
        </div>
    )
}